import { useState } from 'react';

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onChange: (startDate: string, endDate: string) => void;
}

export function DateRangeFilter({ startDate, endDate, onChange }: DateRangeFilterProps) {
  const [preset, setPreset] = useState('30d');

  const applyPreset = (value: string) => {
    setPreset(value);
    if (value === 'custom') return;

    const end = new Date();
    const endStr = end.toISOString().slice(0, 10);
    const days = value === '7d' ? 7 : value === '30d' ? 30 : 90;
    const start = new Date(end);
    start.setDate(start.getDate() - days);
    onChange(start.toISOString().slice(0, 10), endStr);
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <select
        value={preset}
        onChange={(e) => applyPreset(e.target.value)}
        className="border rounded px-3 py-1.5 text-sm bg-white"
        aria-label="Período predefinido"
      >
        <option value="7d">Últimos 7 dias</option>
        <option value="30d">Últimos 30 dias</option>
        <option value="90d">Últimos 90 dias</option>
        <option value="custom">Personalizado</option>
      </select>
      {preset === 'custom' && (
        <>
          <input
            type="date"
            value={startDate}
            onChange={(e) => onChange(e.target.value, endDate)}
            className="border rounded px-2 py-1.5 text-sm"
            aria-label="Data inicial"
          />
          <span className="text-gray-400">a</span>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onChange(startDate, e.target.value)}
            className="border rounded px-2 py-1.5 text-sm"
            aria-label="Data final"
          />
        </>
      )}
    </div>
  );
}
